import React, { useEffect, useRef, useState } from 'react';

const BoxIconOpen = ({ size = 32, className = '' }) => {
  const canvasRef = useRef(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);
      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const data = imageData.data;
      for (let i = 0; i < data.length; i += 4) {
        if (data[i] < 30 && data[i + 1] < 30 && data[i + 2] < 30) {
          data[i + 3] = 0;
        }
      }
      ctx.putImageData(imageData, 0, 0);
      setLoaded(true);
    };
    img.src = '/box.jpg';
  }, []);

  return (
    <canvas
      ref={canvasRef}
      className={className}
      style={{ width: `${size}px`, height: 'auto', opacity: loaded ? 1 : 0 }}
    />
  );
};

export default BoxIconOpen;
